import { LayoutSettings } from "@omni/types/packages/swiper.types";

export const ProductPageConfig = {
    sliders: {
        relatedProducts: {
            xl: { slidesPerGroup: 5, slidesPerView: 5 },
            lg: { slidesPerGroup: 4, slidesPerView: 4 },
            md: { slidesPerGroup: 3, slidesPerView: 3.2 },
            sm: { slidesPerGroup: 3, slidesPerView: 3.2 },
            xs: { slidesPerGroup: 2, slidesPerView: 2.2 }
        } satisfies LayoutSettings,
        recommend: {
            xl: { slidesPerGroup: 5, slidesPerView: 5 },
            lg: { slidesPerGroup: 4, slidesPerView: 4 },
            md: { slidesPerGroup: 3, slidesPerView: 3.2 },
            sm: { slidesPerGroup: 3, slidesPerView: 3.2 },
            xs: { slidesPerGroup: 2, slidesPerView: 2.2 }
        } satisfies LayoutSettings,
        recent: {
            xl: { slidesPerGroup: 6, slidesPerView: 6 },
            lg: { slidesPerGroup: 5, slidesPerView: 5 },
            md: { slidesPerGroup: 4, slidesPerView: 4.2 },
            sm: { slidesPerGroup: 3, slidesPerView: 3.2 },
            xs: { slidesPerGroup: 2, slidesPerView: 2.2 }
        } satisfies LayoutSettings
    }
};
